import { createApp } from 'vue';
import App from '@/pages/app/app';
import router from './router';
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';
import { najizToaster } from '@moj/najiz-toastify';
import NajizValidator from '@moj/najiz-validators';
import { registerGlobalComponents } from './utils/component-registration';
// Styles
// @ts-ignore
import '@moj/vue3-mui/styles';
import '@/assets/styles/main.scss';
import initializeApplication from './plugins/application-initialization';

const app = createApp(App);

registerGlobalComponents(app);

declare global {
  interface Window {
    $config: any;
    $disableNewRequestsPeriod: any;
    showLoader: () => void;
    hideLoader: () => void;
  }
}

initializeApplication(app).then(() => {
  app
    .use(router)
    .use(i18n)
    .use(vuetify)
    .use(najizToaster)
    .use(NajizValidator, { i18n })
    .mount('#app');
});


